import React from 'react';
import { Box } from '@mui/material';

import RoomHeader from '../../../headers/RoomHeader';
import BottomFloatArea from '../../BottomFloatArea';
import RoundPhase from '../../RoundPhase';
import MemberRoomSubMenu from '../MemberRoomSubMenu';

const RESPONSIVE_MODE = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
};

const BOTTOM_FLOAT_CONTENT_PADDING = {
  [RESPONSIVE_MODE.MOBILE]: 85,
  [RESPONSIVE_MODE.DESKTOP]: 85,
};

function MemberRoomLayout({
  betPopups,
  children,
  displayPoint,
  event,
  infomationMessages,
  joinPopups,
  pointChangeAmount,
  responsiveMode,
  round,
  roomDisplayPhase,
  updateRound,
  user,
  viewProps,
}) {
  const isMobile = responsiveMode === RESPONSIVE_MODE.MOBILE;
  const bottomContentPadding = BOTTOM_FLOAT_CONTENT_PADDING[responsiveMode] ?? BOTTOM_FLOAT_CONTENT_PADDING[RESPONSIVE_MODE.DESKTOP];

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      width="100%"
      minHeight="100vh"
    >
      {/* ヘッダー */}
      <RoomHeader user={user} drawerOnlyOnMobile={isMobile} />
      <RoundPhase
        event={event}
        responsiveMode={responsiveMode}
        round={round}
        roomDisplayPhase={roomDisplayPhase}
        userType="member"
        updateRound={updateRound}
      />

      <BottomFloatArea
        betPopups={betPopups}
        displayPoint={displayPoint}
        joinPopups={joinPopups}
        messages={infomationMessages}
        pointChangeAmount={pointChangeAmount}
        responsiveMode={responsiveMode}
      />

      {/* phase content */}
      <Box
        sx={{
          width: isMobile ? '100%' : 'min(1240px, 100%)',
          pb: `calc(${bottomContentPadding}px + env(safe-area-inset-bottom))`,
          px: isMobile ? 0 : { sm: 2, md: 3 },
          boxSizing: 'border-box',
          display: isMobile ? 'flex' : 'grid',
          flexDirection: isMobile ? 'column' : undefined,
          gridTemplateColumns: isMobile ? undefined : 'minmax(0, 1fr) 64px',
          gap: isMobile ? 0 : { sm: 1.5, md: 2 },
          alignItems: isMobile ? 'center' : 'start',
        }}
      >
        <Box
          sx={{
            width: '100%',
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
          }}
        >
          {children}
        </Box>
        <MemberRoomSubMenu responsiveMode={responsiveMode} {...viewProps} />
      </Box>
    </Box>
  );
}

export default MemberRoomLayout;
